'use client'
import { useEffect, useState } from "react";
import styles from './styles.module.css';

export default function Dropdown({options, chosenOption, setChosenOption, field, clearField}: any) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedOption, setSelectedOption] = useState(chosenOption);
  const [filteredValues, setFilteredValues] = useState(options);

  const openDropdown = () => { 
    setShowDropdown(!showDropdown);
  }
  
  const chooseOption = ( option: string ) => {
    setSelectedOption(option);
    setShowDropdown(false);
    setChosenOption(field, option);
  }

  const filterValues = (event: any) => {
    const temp = options.filter((el: any) => el.name.toLowerCase().includes(event.target.value.toLowerCase()));
    setSelectedOption(event.target.value);
    setFilteredValues(temp);
  }

  useEffect(() => {
    setChosenOption(field, '');
    setSelectedOption('');
    setFilteredValues(options);
  }, [clearField])

  return (
    <>
      <div className="relative inline-block text-left w-full">
        <div className={styles['input-border']}>
          <div
            onClick={openDropdown}
            className="inline-flex w-full text-[16px] rounded-[20px] h-[56px] items-center justify-between gap-x-1.5 bg-white px-7 py-2 text-[#8e8e8e] shadow-sm"
            style={{ background: 'linear-gradient(90deg, #190A2B 0%, #19092A 100%)'}}
            id="menu-button"
            aria-expanded="true"
            aria-haspopup="true"
          >
            <input value={selectedOption} onChange={() => filterValues(event)} type='text' placeholder="Select a country" className={styles.search}/>
            <svg
              className="-mr-1 h-5 w-5 text-[#7D34D0]"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </div>
        <div
          className={`${showDropdown ? 'block' : 'hidden'} absolute h-fit max-h-[300px] overflow-auto text-white right-0 z-10 mt-2 w-full origin-top-right rounded-md  shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`}
          style={{ background: 'linear-gradient(90deg, #190A2B 0%, #19092A 100%)'}}
          role="menu"
          id="form-dropdown"
          aria-orientation="vertical"
          aria-labelledby="menu-button"
        >
          <div className="py-4" role="none">
            {
              filteredValues.map((option: any, index: number) => {
                return (
                  <div 
                    onClick={() => {chooseOption(option.name)}}
                    key={index}
                    className="text-white block px-4 py-2 text-sm cursor-pointer"
                    role="menuitem"
                  >
                    {option.name}
                  </div>
                )
              })
            }
            {
              !filteredValues.length && <span className={styles.noOption}>No option found.</span>
            }
          </div>
        </div>
      </div>
    </>
  );
}
